import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import callAPI from "../../../../../api/apiCaller";
import Button from "../../../../../common/Button";
import Loading from "../../../../../common/Loading";
import Modal from "../../../../../common/Modal";
import { Actions } from "../../ProgramContent/ProgramParticipants/ActiveParticipants/styles";
import Icon from "../../../../../common/Icon";
import TextInput from "../../../../../common/TextInput";
import {
  ReassignMenteeContainer,
  MentorRow,
  MentorName,
  MentorInfo,
  MentorImage,
  SearchBoxContainer,
  SearchIcon,
  TitleBorderSeperator,
} from "./styles";
import { Context } from "../../../../../Store";
import MenteeMatch from "./MenteeMatch";

function ReassignMentee({
  menteeId,
  mentee,
  closeModal,
  program,
  team,
  getMyTeam,
  programInformation,
}) {
  const params = useParams();
  // const programId = params.selectedProgram;
  const [isReassigning, setIsReassigning] = React.useState(false);
  const [action, setAction] = React.useState(null);
  const { state, dispatch } = React.useContext(Context);
  const [matchModal, setMatchModal] = useState(false);
  const [matchedParticipants, setMatchedParticipants] = useState([]);
  const [successModal, setSuccessModal] = useState(false);
  const getAvailableMentor = () => {
    callAPI(dispatch, "getAvailableMentors", {
      id: params.selectedProgram,
    }).then((res) => {
      if (res.isResponseOk) {
        setMentorList(res.data);
      }
    });
  };

  React.useEffect(() => {
    getAvailableMentor();
  }, []);

  function reassignMentee(mentorId, uniqueMenteeId) {
    setIsReassigning(mentorId);
    callAPI(dispatch, "reassignMentee", {
      id: params.selectedProgram,
      mentorId: mentorId,
      menteeId: uniqueMenteeId,
    }).then((res) => {
      setSuccessModal(true);
      // closeModal(true);
      // setIsReassigning(false);
    });
  }

  function assignMember(TeamId, Role) {
    setIsReassigning(TeamId);
    callAPI(dispatch, "AssignMemberToTeam", {
      // id: params.selectedProgram,
      teamId: TeamId,
      userId: +menteeId,
      role: Role,
    }).then((res) => {
      closeModal(true);
      setIsReassigning(false);
      getAvailableMentor();
      getMyTeam();
      programInformation();
    });
  }

  /****** */
  const [mentorList, setMentorList] = React.useState(null);

  const [searchMentor, setSearchMentor] = React.useState("");
  const [filteredData, setFilteredData] = useState(null);

  // useEffect(() => {
  //   if(mentorList){
  //     setFilteredData(mentorList);
  //   }
  // }, [mentorList]);

  console.log("mentorList:", mentorList);

  useEffect(() => {
    if (!searchMentor) {
      setFilteredData(mentorList);
      return;
    }

    const searchTerm = searchMentor.toLowerCase();

    const filterParticipant = mentorList?.filter((item) => {
      const firstName = item?.participant?.firstName?.toLowerCase() || "";
      const lastName = item?.participant?.lastName?.toLowerCase() || "";

      return (
        firstName.startsWith(searchTerm) || lastName.startsWith(searchTerm)
      );
    });

    setFilteredData(filterParticipant);
  }, [searchMentor, mentorList]);
  /****** */

  if (program?.programType !== "TEAM" && mentorList === null) {
    return (
      <Modal
        onClose={() => {
          closeModal(false);
        }}
        title="Reassign Mentee"
      >
        <Loading loadingItem="Available Mentors" />
      </Modal>
    );
  }

  if (program?.programType === "TEAM" && !team) {
    return (
      <Modal
        onClose={() => {
          closeModal(false);
        }}
        title="Reassign Member"
      >
        <Loading loadingItem="Team Members" />
      </Modal>
    );
  }

  return (
    <>
      {menteeId && (
        <Modal
          onClose={() => {
            closeModal(false);
          }}
          title={
            program?.programType === "TEAM" ? "Assign Member" : "Assign Mentee"
          }
          actions={[
            {
              text: "Cancel",
              onClick: () => {
                closeModal(false);
              },
            },
          ]}
        >
          <TitleBorderSeperator>
            <SearchBoxContainer>
              <SearchIcon>
                <Icon type="search" />
              </SearchIcon>
              <TextInput
                placeholder="Search for Participant"
                // value={searchText}
                // setValue={setSearchText}
                value={searchMentor}
                setValue={setSearchMentor}
                isIcon={true}
              />
            </SearchBoxContainer>
          </TitleBorderSeperator>
          {program?.programType === "TEAM" ? (
            <ReassignMenteeContainer>
              {team &&
                team.map((member) => {
                  return (
                    <MentorRow>
                      <MentorInfo>
                        <MentorImage
                          src={
                            member?.media
                              ? member?.media
                              : "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png"
                          }
                        />
                        <MentorName>{member?.name}</MentorName>
                      </MentorInfo>
                      <Actions>
                        <Button
                          onClick={() => {
                            setAction("mentorAssigned");
                            assignMember(member.id, "mentor");
                          }}
                          variant="secondary"
                          text="Assign As Mentor"
                          icon={
                            isReassigning === member.id &&
                            action === "mentorAssigned"
                              ? "loading"
                              : "tick"
                          }
                        />
                        <Button
                          onClick={() => {
                            setAction("memberAssigned");
                            assignMember(member.id, "member");
                          }}
                          variant="primary"
                          text="Assign"
                          icon={
                            isReassigning === member.id &&
                            action === "memberAssigned"
                              ? "loading"
                              : "tick"
                          }
                        />
                      </Actions>
                    </MentorRow>
                  );
                })}
            </ReassignMenteeContainer>
          ) : (
            <ReassignMenteeContainer>
              {filteredData?.map((mentor) => {
                return (
                  <MentorRow>
                    <MentorInfo>
                      <MentorImage
                        src={
                          mentor.participant.image
                            ? mentor.participant.image
                            : "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png"
                        }
                      />
                      <MentorName>
                        {mentor.participant.firstName +
                          " " +
                          mentor.participant.lastName}
                      </MentorName>
                    </MentorInfo>
                    <Actions>
                      <Button
                        onClick={() => {
                          setMatchedParticipants([mentee, mentor]);
                          setMatchModal(true);
                          // reassignMentee(mentor.id);
                        }}
                        variant="primary"
                        text="Assign"
                        icon={isReassigning === mentor.id ? "loading" : "tick"}
                      />
                    </Actions>
                  </MentorRow>
                );
              })}
            </ReassignMenteeContainer>
          )}
        </Modal>
      )}
      <MenteeMatch
        reassignMentee={reassignMentee}
        matchedParticipants={matchedParticipants}
        isOpen={matchModal}
        closeModal={() => {
          setMatchModal(false);
          closeModal(false);
        }}
        isClose={closeModal}
        successModal={successModal}
        setSuccessModal={setSuccessModal}
      />
    </>
  );
}
export default ReassignMentee;
